import React from "react";
import {
  Grid,
  GridItem,
  Input,
  Select,
  Button,
  HStack,
} from "@chakra-ui/react";
import {
  SOURCE_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
  PAGE_SIZE_OPTIONS,
} from "../constants/filters";

const ResumeFilters = ({ filters, onFilterChange, onReset }) => {
  return (
    <Grid templateColumns={{ base: "1fr", md: "repeat(5, 1fr)" }} gap={3}>
      <GridItem>
        <Input
          value={filters.location}
          onChange={(e) => onFilterChange("location", e.target.value)}
          placeholder="Location"
        />
      </GridItem>
      <GridItem>
        <Input
          value={filters.experienceMin}
          onChange={(e) => onFilterChange("experienceMin", e.target.value)}
          placeholder="Min experience"
          type="number"
        />
      </GridItem>
      <GridItem>
        <Input
          value={filters.experienceMax}
          onChange={(e) => onFilterChange("experienceMax", e.target.value)}
          placeholder="Max experience"
          type="number"
        />
      </GridItem>
      <GridItem>
        <Select
          value={filters.source}
          onChange={(e) => onFilterChange("source", e.target.value)}
        >
          {SOURCE_FILTER_OPTIONS.map((option) => (
            <option key={option.value || "all"} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </GridItem>
      <GridItem>
        <Select
          value={filters.status}
          onChange={(e) => onFilterChange("status", e.target.value)}
        >
          {STATUS_FILTER_OPTIONS.map((option) => (
            <option key={option.value || "all"} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </GridItem>
      <GridItem>
        <HStack>
          <Select
            value={filters.limit}
            onChange={(e) => onFilterChange("limit", Number(e.target.value))}
          >
            {PAGE_SIZE_OPTIONS.map((size) => (
              <option key={size} value={size}>
                {size} / page
              </option>
            ))}
          </Select>
          <Button variant="outline" onClick={onReset}>
            Reset
          </Button>
        </HStack>
      </GridItem>
    </Grid>
  );
};

export default ResumeFilters;
